import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedClientAction, updateClientAction } from '../../../redux/actions/clientsActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import ClientForm from '../forms/ClientForm';

const UpdateClientModal = ({ readOnly, onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const client = useSelector((state) => state.clients?.client);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(updateClientAction(data));
    await dispatch(clearSelectedClientAction());
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Змінити інформацію клієнта'}
      loading={loading}
      onClose={onModalClose}
      body={<ClientForm readOnly={readOnly} onSubmit={onSubmit} loading={loading} initClient={client} />}
      actionButton={
        !readOnly && (
          <Button type={'submit'} disabled={loading} variant={'primary'} formId={'client-form'} children={'Змінити'} />
        )
      }
    />
  );
};

export default UpdateClientModal;
